export const SITE_ORIGIN = "https://www.plagelpc.com";
export const SEO_LANGUAGES = ["fr", "en", "it", "x-default"] as const;

export const PUBLIC_PAGE_PATHS = [
  "/",
  "/actualites",
  "/evenements-prives",
  "/menu",
  "/faq",
  "/mentions-legales",
  "/politique-de-confidentialite",
] as const;

export function normalizeSeoPath(path: string): string {
  const pathname = path.split(/[?#]/, 1)[0];
  const rooted = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return rooted.replace(/\/+$/, "") || "/";
}

export function canonicalUrl(path: string): string {
  return `${SITE_ORIGIN}${normalizeSeoPath(path)}`;
}

export function isPublicSeoPath(path: string): boolean {
  const normalized = normalizeSeoPath(path);
  return PUBLIC_PAGE_PATHS.some((page) => page === normalized)
    || /^\/actualites\/[^/]+$/.test(normalized);
}